<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      :value="modelValue"
      v-bind="$attrs"
      :ref="inputRef"
      :id="inputId"
      :class="[inputClass, {has_error: error}]"
      :name="inputName"
      type="password"
      inputmode="numeric"
      @input="handleModelValueChange"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>

  <div v-if="isErrorMessageVisible" class="error_text">{{ errorMessage }}</div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, useTemplateRef } from 'vue';
import useTextInputHook from '@/hooks/useTextInput.js';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  inputRef: {
    type: String,
    default: 'base-password-input-ref',
  },
  inputId: {
    type: String,
    default: 'inputPassword',
  },
  maxSize: {
    type: Number,
    default: null,
  },
  inputClass: {
    type: String,
    default: 'password',
  },
  inputName: {
    type: String,
    default: 'password',
  },
  error: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
});

const modelValue = defineModel({
  type: String,
});

const basePasswordInputRef = useTemplateRef(props.inputRef);

const {
  isLabelCollapsed,
  isErrorMessageVisible,
  addInputAnimationListener,
  removeInputAnimationListener,
  handleInputFocus,
  handleInputBlur,
} = useTextInputHook(modelValue, basePasswordInputRef, () => ({ error: props.error, errorMessage: props.errorMessage }));

const handleModelValueChange = (event) => {
  const newValue = event.target.value;

  if (props.maxSize && (newValue.length > props.maxSize)) {
    event.target.value = newValue.slice(0, props.maxSize);
  } else {
    modelValue.value = event.target.value;
  }
};

onMounted(addInputAnimationListener);

onBeforeUnmount(removeInputAnimationListener);
</script>
